import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VehicleInquiry } from '../models/vehicle-inquiry ';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceService } from './data-source-service.ts';

@Injectable({
  providedIn: 'root'
})
export class VehicleInquiryService {

  constructor(private http: HttpClient,
    private dataSourceService: DataSourceService
  ) { }

  public apiUrl = `${environment.apiUrl}/vehicleInquiries`;

  getList(): Observable<any> {
    return this.http.get(`${this.apiUrl}`)
  }

  async getDataSource(): Promise<CustomStore<any, any>> {
    return this.dataSourceService.getDataSource(this.apiUrl)
  }

  getLookupData(): Observable<any>{
    return this.http.get(`${this.apiUrl}/getLookupData`)
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`)
  }

  getPdf(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/GetPdf?id=${id}`)
  }

  getSvg(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/GetSvg?id=${id}`)
  }

  update(id: number, vehicleInquiry: VehicleInquiry) {
    return this.http.put(`${this.apiUrl}?id=${id}`, vehicleInquiry)
  }

  delete(id: number) {
    return this.http.delete(`${this.apiUrl}/${id}`)
  }

}
